export default __webpack_public_path__ + "static/media/understanding-patent.d4d2fa82.gif";